import service from "../util/http";
import bxService from "../util/bx";


//获取客户（国家）列表
export const customerCountryList = (data) => {
  return service({
    url: "/manage/survey/customerCountryList",
    method: "post",
    data,
  });
};
//获取问卷列表
export const surveyLs = (data) => {
  return service({
    url: "/manage/survey/list",
    method: "post",
    data,
  });
};
//问卷发布、撤回
export const surveyPost = (data) => {
  return service({
    url: "/manage/survey/changeStatus",
    method: "post",
    data,
  });
};
//问卷删除
export const surveyDel = (data) => {
  return service({
    url: "/manage/survey/deleteWithParticipants",
    method: "post",
    data,
  });
};
//问卷新增
export const surveyAdd = (data) => {
  return service({
    url: "/manage/survey/createWithParticipants",
    method: "post",
    data,
  });
};
//问卷新增
export const surveyUpdate = (data) => {
  return service({
    url: "/manage/survey/updateWithParticipants",
    method: "post",
    data,
  });
};
//问卷详情
export const surveyget = (data) => {
  return service({
    url: "/manage/survey/get",
    method: "post",
    data,
  });
};